import { Text } from '@ekhodealer/ekho-common/rev';

import type { OrderTimelineNote } from '@ekhodealer/ekho-common';

import { InfoLineItem } from '@common/components/InfoLineItem';

interface TimelineNoteItemProps {
	note: OrderTimelineNote;
}

/**
 * TimelineNoteItem component
 * Displays a single timeline note using InfoLineItem
 */
export const TimelineNoteItem = ({ note }: TimelineNoteItemProps) => {
	// Build title with author name and formatted date
	const title = `${note.authorName} · ${note.formattedDate}`;

	// Build forwarding indicators if note was sent to Slack or buyer
	const forwardingInfo = [];
	if (note.sendToCommChannels) {
		forwardingInfo.push('Forwarded to Ekho Slack channel');
	}
	if (note.sendToBuyer) {
		forwardingInfo.push('Forwarded to Buyer');
	}

	// Combine note content with forwarding info if present
	const content = (
		<>
			<Text size='body'>{note.noteContent}</Text>
			{forwardingInfo.length > 0 && (
				<Text size='footnote' color='secondary'>
					{forwardingInfo.join(' · ')}
				</Text>
			)}
		</>
	);

	return <InfoLineItem title={title} content={content} />;
};
